<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-navegacao [data]="data.NAVEGACAO"></app-navegacao>